import styled from 'styled-components';

const ToggleLabel = styled.label<{disabled: boolean}>`
    display: inline-flex;
    align-items: center;
    gap: 0.65rem;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    color: ${(props) => (props.disabled ? 'rgb(150, 150, 150)' : 'inherit')};
`;

const HiddenCheckbox = styled.input`
    position: absolute;
    opacity: 0;
    pointer-events: none;
`;

const ToggleTrack = styled.span<{checked: boolean; disabled: boolean}>`
    position: relative;
    width: 2.4rem;
    height: 1.35rem;
    border-radius: 999px;
    background: ${(props) => {
        if (props.disabled) return props.checked ? 'rgb(170, 200, 170)' : 'rgb(220, 220, 220)';
        return props.checked ? 'rgb(74, 167, 92)' : 'rgb(200, 200, 200)';
    }};
    transition: background-color 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: ${(props) => (props.checked ? 'calc(100% - 2px)' : '2px')};
        width: 0.95rem;
        height: 0.95rem;
        border-radius: 50%;
        background: white;
        transform: ${(props) =>
            props.checked ? 'translate(-100%, -50%)' : 'translate(0, -50%)'};
        transition: left 0.2s ease, transform 0.2s ease;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
    }
`;

const ToggleText = styled.span`
    line-height: 1.2;
`;

export function ToggleControl({
    label,
    checked,
    disabled = false,
    onChange
}: {
    label: string;
    checked: boolean;
    disabled?: boolean;
    onChange: ({checked}: {checked: boolean}) => void;
}) {
    return (
        <ToggleLabel disabled={disabled}>
            <HiddenCheckbox
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange({checked: e.target.checked})}
            />
            <ToggleTrack checked={checked} disabled={disabled} />
            <ToggleText>{label}</ToggleText>
        </ToggleLabel>
    );
}